<template>
  <div id="index">
    <div id="header">
      <div class="logo">
        <img src="../assets/images/log.png"/>
      </div>
      <div class="navigation">
        <ul>
          <li><a href="javascript:void(0);" @click="jump('index')">首页</a></li>
          <li><a href="javascript:void(0);" @click="jump('product')">产品中心</a></li>
          <li><a href="javascript:void(0);" @click="jump('scheme')">解决方案</a></li>
          <li><a href="javascript:void(0);" @click="jump('service')">运营服务</a></li>
          <li><a href="javascript:void(0);" @click="jump('cases')">成功案例</a></li>
          <li><a href="javascript:void(0);" @click="jump('cases1')">直播分享</a></li>
          <li><a href="javascript:void(0);" @click="jump('contact')">联系我们</a></li>
        </ul>
      </div>
    </div>

    <div v-show="showMain">
      <div id="carousel">
        <el-carousel height="640px">
          <el-carousel-item>
            <img src="../assets/images/banner1.png"/>
          </el-carousel-item>
          <el-carousel-item>
            <img src="../assets/images/banner2.png"/>
          </el-carousel-item>
          <el-carousel-item>
            <img src="../assets/images/banner3.png"/>
          </el-carousel-item>
        </el-carousel>
      </div>

      <div id="intro">
        <div class="intro-img">
          <img src="../assets/images/公司简介.png"/>
        </div>
        <div class="intro-item">
          <h2>公司简介</h2>
          <h6>ABOUT US</h6>
          <p>江苏朗拓健康科技有限公司成立于2013年，是一家专业从事医疗卫生领域信息化系统建设的企业。公司一直扎根于智慧医疗领域，经过多年的持续发展及行业沉淀，已成为集医疗软件的研发、销售、运营和系统集成为一体的专业智慧医疗产品及解决方案供应商。公司拳头产品药迅处方共享平台致力于应用国际先进的PBM（医药福利管理）模式与技术，专注于中国医药与大健康产业，为处方流转提供了综合性解决方案和软件平台。</p>
          <p>江苏朗拓紧跟中国医改政策趋势，密切关注中国医药市场动态。“让百姓就医更便捷”是公司的使命，持续提升医药流通效率、降低采购成本、保障百姓用药及时安全是我们不变的追求。朗拓智慧医院目前在国内多家医院成功实施并稳定运行，公司已成为腾讯互联网+医疗、妙手医生等核心合作伙伴。</p>
        </div>
      </div>

      <div id="trends">
        <h2>新闻动态</h2>
        <h6>——TRENDS——</h6>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="trends-item-left">
              <img src="../assets/images/新闻动态1.png"/>
              <h5>2018-11-22</h5>
              <h4 @click="showTrend(4)">【双喜临门】我们搬家了</h4>
              <p>今天是感恩节，值此佳节，恭喜江苏朗拓健康科技有限公司乔迁之喜！让我们在新的城池继续开疆拓土...</p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="trends-item-right">
              <img src="../assets/images/新闻动态2.png"/>
              <h5>2018-10-29</h5>
              <h4 @click="showTrend(3)">【号外】朗拓健康携“互联网+医疗健康...</h4>
              <p>2018中国研究型医院学会移动医疗专业委员会年会暨第五届“互联网+医疗”学术高峰论坛于2018年10月26...</p>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="trends-item-left">
              <img src="../assets/images/新闻动态3.png"/>
              <h5>2018-08-06</h5>
              <h4 @click="showTrend(2)">药迅处方共享平台亮相互联网+医联体...</h4>
              <p>2018年8月4日，互联网+医联体模式下三级医院信息化建设现场会在连云港第一人民医院隆重举行！江苏...</p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="trends-item-right">
              <img src="../assets/images/新闻动态4.png"/>
              <h5>2018-07-29</h5>
              <h4 @click="showTrend(1)">互联网诊疗管理办法（试行）</h4>
              <p>第一条 为落实《国务院办公厅关于促进“互联网+医疗健康”发展的意见》，规范互联网诊疗活动，推动互...</p>
            </div>
          </el-col>
        </el-row>
        <div class="button">
          <button @click="showTrend(0)">查看更多</button>
        </div>
      </div>

      <div id="product">
        <h2>产品中心</h2>
        <h6>——PRODUCT——</h6>
        <h6>建设“互联网+医疗健康”便民服务平台，打造“互联网+医疗健康”便民服务新模式</h6>
        <el-row :gutter="12">
          <el-col :span="8">
            <el-card shadow="hover">
              <div class="pro-img">
                <img src="../assets/images/互联网医院.png">
              </div>
              <div class="pro-item">
                <h3>互联网医院</h3>
                <p>以医院卫生信息平台为基础，采取“医院主导、企业共建、服务全民”的建设模式，提升医院互联网+医疗健康便民服务能力</p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card shadow="hover">
              <div class="pro-img">
                <img src="../assets/images/处方共享平台.png">
              </div>
              <div class="pro-item">
                <h3>处方共享平台</h3>
                <p>基于国家“互联网+医疗健康”发展意见，完善药品供应保障服务，为患者打通院外购药及第三方药品配送到家全流程，实现患者自主选择线上和线下相结合的购药方式</p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card shadow="hover">
              <div class="pro-img">
                <img src="../assets/images/智能慢病管理.png">
              </div>
              <div class="pro-item">
                <h3>智能健康管理系统</h3>
                <p>通过智能健康管理系统，建立电子健康档案，为患者提供综合、定制化、连续、全流程健康管理服务，实现监测-评价-个性化干预-再监测-再评价-再干预的闭环管理流程</p>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>

      <div id="scheme">
        <h2>解决方案</h2>
        <h6>——SCHEME——</h6>
        <div>
          <el-carousel type="card" :interval="4000" height="500px">
            <el-carousel-item>
             <img src="../assets/images/2.1.png"/>
              <div class="sch-item">
                <h3>健康管理解决方案</h3>
                <p>
                  构建医生和患者的服务连接。患者可通过多终端在线向医生发起服务申请，医生可为患者提供复诊、健康咨询、随访及健康教育等管理服务，将医疗健康服务从院内延伸到院外，从诊中延伸到诊前诊后，拓展医院服务内涵，构建连续的医疗健康服务新模式。
                </p>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <img src="../assets/images/1.1.png"/>
              <div class="sch-item">
                <h3>互联网医院解决方案</h3>
                <p>
                  构建医院和患者的连接，为居民提供导诊、预约、支付、报告查询等就医服务，通过视讯技术开展在线复诊、在线医嘱（检查单、检验单、电子处方）、在线评估、在线审方、处方流转等线上服务，实现医院诊疗数据的线上线下融合，构建完整的互联网线上诊疗服务闭环。
                </p>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <img src="../assets/images/3.1.png"/>
              <div class="sch-item">
                <h3>处方共享平台解决方案</h3>
                <p>
                  基于互联网技术，以患者为核心，联合食药监局、社保、医院、社会药店等单位，将医疗机构电子处方共享至院边药房、社区药房或线上药品电商，打通患者院外购药及第三方药品配送到家全流程服务，实现医疗机构处方信息、医保结算信息和药品零售消费信息的互联互通、实时共享。
                </p>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <div id="service">
        <h2>运营服务</h2>
        <h6>——SERVICE——</h6>
        <el-row :gutter="12">
          <el-col :span="8">
            <el-card shadow="hover">
              <div class="service-img">
                <img src="../assets/images/造入口.png">
                <h4>造入口</h4>
              </div>
              <div class="service-item">
                <h4>医院公众号</h4>
                <h5>专业技术支持</h5>
                <h5>线上线下活动</h5>
              </div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card shadow="hover">
              <div class="service-img">
                <img src="../assets/images/扩规模.png">
                <h4>扩规模</h4>
              </div>
              <div class="service-item">
                <h4>专业运营</h4>
                <h5>量化运营目标</h5>
                <h5>专业客服团队</h5>
              </div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card shadow="hover">
              <div class="service-img">
                <img src="../assets/images/促活跃.png">
                <h4>促活跃</h4>
              </div>
              <div class="service-item">
                <h4>便民服务</h4>
                <h5>运营数据分析</h5>
                <h5>运营资源支持</h5>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>

      <div id="cases">
        <h2>成功案例</h2>
        <h6>——CASES——</h6>
        <el-row :gutter="12">
          <el-col :span="8">
            <div class="case-item">
              <img src="../assets/images/1.png">
              <h5>中山大学附属第一医院处方共享平台建设</h5>
              <p>
                中山大学附属第一医院地处广东省省会广州市，是国家重点大学中山大学附属医院中规模最大、综合实力最强的附属医院，也是国内规模最大 、综合实力最强的医院之一。
              </p>
              <p>
                我司承建医院处方共享平台项目，为医院搭建处方共享平台，医院所有的可流转药品都通过平台共享到第三方机构，由第三方机构提供中药代煎及药品配送服务。
              </p>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="case-item">
              <img src="../assets/images/2.png">
              <h5>杭州市余杭区处方共享平台建设</h5>
              <p>
                余杭区地处杭州市区西、北部，总面积1228.41平方千米，全区户籍人口98.46万人。截至2016年末，全区共有各类医疗卫生机构490家，其中区属医院7家，社区卫生服务中心20家。
              </p>
              <p>
                我司与阿里巴巴集团合作，承建健康余杭项目中处方共享模块，搭建余杭区虚拟中心药房，为居民、社区提供扩展药品目录、药事延伸服务。
              </p>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="case-item">
              <img src="../assets/images/3.png">
              <h5>蚌埠市妇幼保健院互联网医院及处方共享平台建设</h5>
              <p>
                蚌埠市妇幼保健院成立于1984年7月，承担着对全市的专科业务指导和培训。曾荣获卫生部授予的“全国卫生文明建设先进集体”、“全国卫生系统先进集体”、省卫生厅授予的“省妇幼卫生文明单位” 等光荣称号。
              </p>
              <p>
                2018年，我公司与医院签订互联网医院共建协议，由我公司负责医院互联网医院及处方共享平台建设，并联合运营。
              </p>
            </div>
          </el-col>
        </el-row>
      </div>
      <div id="cases1">
        <h2>直播分享</h2>
        <h6>——LIVE——</h6>
        <div style="padding-left: 200px;">
          <span v-for="(item ,index) in hosList" :class="{to_active:shows==item.sn}" style="margin-left: 10px;" @click="getHospital(item.sn)">{{item.hosName}}</span>
        </div>
        <el-row :gutter="12" v-if="shows=='1'">
          <el-col :span="8">
            <div class="case-item">
              <a :href="liveInfo[0].liveUrl" target="_blank"><img :src="liveInfo[0].img"></a>
              <h5>{{liveInfo[0].liveName}}</h5>
              <p>
                {{liveInfo[0].hosName}}&nbsp&nbsp{{liveInfo[0].doctorName}}&nbsp&nbsp{{liveInfo[0].doctorTitle}}
              </p>
              <p>
               {{liveInfo[0].liveTime}}
              </p>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="case-item" style="margin-left: 10px;">
              <a :href="liveInfo[1].liveUrl" target="_blank"><img :src="liveInfo[1].img"></a>
              <h5>{{liveInfo[1].liveName}}</h5>
              <p>
                {{liveInfo[1].hosName}}&nbsp&nbsp{{liveInfo[1].doctorName}}&nbsp&nbsp{{liveInfo[1].doctorTitle}}
              </p>
              <p>
                {{liveInfo[1].liveTime}}
              </p>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="case-item" style="margin-left: 10px;">
              <a :href="liveInfo[2].liveUrl" target="_blank"><img :src="liveInfo[2].img"></a>
              <h5>{{liveInfo[2].liveName}}</h5>
              <p>
                {{liveInfo[2].hosName}}&nbsp&nbsp{{liveInfo[2].doctorName}}&nbsp&nbsp{{liveInfo[2].doctorTitle}}
              </p>
              <p>
                {{liveInfo[2].liveTime}}
              </p>
            </div>
          </el-col>
        </el-row>
        <div class="button" v-if="liveInfo.length>=4&&shows=='1'">
          <button @click="showLive()">查看更多</button>
        </div>
      </div>
    </div>

    <TrendList ref="trend" v-show="showTrendList"></TrendList>
    <LiveList ref="live" v-show="showLiveList"></LiveList>

    <div id="contact">
      <div class="wechat">
        <img src="../assets/images/ma.png"/>
        <p>官方微信</p>
      </div>
      <div class="contact-info">
        <p>商业合作：400-167-2880</p>
        <p>邮箱：langtuo@langtuojs.com</p>
        <p>地址：南京市秦淮区晨光1865创意产业园E10栋三楼</p>
      </div>
      <div class="declare">
        <p>Copyright @2016-2021.江苏朗拓健康科技有限公司.苏ICP备 18052330号</p>
      </div>
    </div>

    <div class="go-top" v-if="btnFlag" @click="backTop">
      <img src="../assets/images/top.png">
    </div>

  </div>
</template>

<script  type="text/javascript">
  import TrendList from "./trend/TrendList"
  import LiveList from "./live/LiveList"
  export default {
    name: 'Index',
    components:{TrendList,LiveList},
    data () {
      return {
        btnFlag: false,
        showMain: true,
        showTrendList: false,
        showLiveList:false,
        liveInfo:this.$global_variable.liveInfo,
        hosList:this.$global_variable.hosList,
        shows:'1'
      }
    },
    mounted () {
      window.addEventListener('scroll', this.scrollToTop)
    },
    destroyed () {
      window.removeEventListener('scroll', this.scrollToTop)
    },
    methods:{
      // 点击图片回到顶部方法，加计时器是为了过渡顺滑
      backTop () {
        let that = this
        let timer = setInterval(() => {
          let ispeed = Math.floor(-that.scrollTop / 5)
          document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
          if (that.scrollTop === 0) {
            clearInterval(timer)
          }
        }, 16)
      },
      // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
      scrollToTop () {
        let that = this
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        that.scrollTop = scrollTop
        if (that.scrollTop > 60) {
          that.btnFlag = true
        } else {
          that.btnFlag = false
        }
      },
      jump(str){
        this.showTrendList = false
        this.showMain = true
        this.showLiveList =false
        this.$nextTick(function(){
          document.querySelector("#"+str).scrollIntoView(true);
        })
      },
      showTrend(index){
        this.showTrendList = true
        this.showMain = false
        this.$refs.trend.index = index
        this.$refs.trend.init()
        window.scrollTo(0,0)
      },
      showLive(){
        this.showLiveList = true
        this.showMain = false
        this.$refs.live.shows=this.shows
        window.scrollTo(0,0)
      },
      getHospital(type){
        if(type===type){
          this.shows=type
        }

      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import '@/assets/css/Index.scss';
</style>
<style lang="scss">
  .to_active {background: #F5F5F5!important;color: #0079FE;border-bottom: 2px solid #0079FE; }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue